import { createElement } from "@wordpress/element";
import { setup as setupStyled } from "goober";
import "./block/index";
import "./classic/index";
import './preview';
import './notice';

import "./editor.scss";
import "./main.scss";


setupStyled(createElement);